
import {Component, Vue} from "vue-property-decorator";
import {renewalProductKeyForPath, RenewalProductKey} from "@/utils/renewalOffer";

// 30-21 gün kademesinde header'da görünen sakin yenileme butonu.
// Modal kademesinde (20-8 gün) de görünür kalır ki teklif her an erişilebilir olsun.
@Component
export default class RenewalButton extends Vue {
  loading = false;

  // $route.path reaktif: ürün geçişinde anahtar ve teklif otomatik güncellenir.
  get productKey(): RenewalProductKey {
    return renewalProductKeyForPath(this.$route.path);
  }

  get offer() {
    return this.$store.getters.renewalOfferFor(this.productKey);
  }

  get visible(): boolean {
    const offer = this.offer;
    return !!offer?.eligible && (offer.tier === 'button' || offer.tier === 'modal');
  }

  async onClick() {
    this.loading = true;
    try {
      await this.$store.dispatch('startRenewalCheckout', this.productKey);
    } finally {
      this.loading = false;
    }
  }
}
